import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ModalVideo from 'react-modal-video';

// ES6 class-style
class OurTeachers extends PreLoginSessionCheck {
  

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
    this.goNext = this.goNext.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.swiper = null
  }

  goNext() {
    if (this.swiper) this.swiper.slideNext()
  }
 
  goPrev() {
    if (this.swiper) this.swiper.slidePrev()
  }

  openModal (someValue) {
    this.setState({isOpen: true})
    this.videoId = someValue
    console.log(this.videoId);
  }

  render() {
  	const videoId = '';
	const params = {
		slidesPerView: 3,
	 	spaceBetween: 30,
	 	loop: true,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	        nextButtonCustomizedClass:'.swp-next',
	    	prevButtonCustomizedClass:'.swp-prev'	
	    },
	    breakpoints: {
		    480: {
		      slidesPerView: 1,
		      spaceBetween: 20
		    },
		    640: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    },
		    768: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    }
		}
    }

  	return(
  	<section className="mtb our-student">
		<div className="row">
			<div className="container">
				<h4>{this.rb("ourteachers.heading")}</h4> 
				
				<Swiper className="student-slider" slidesPerView={params.slidesPerView}  breakpoints={params.breakpoints} loop={params.loop} spaceBetween={params.spaceBetween} ref={node => {if(node) this.swiper = node.swiper} }>
					
					<div data-ga="Our Learnings - We collaborate closely with teachers - Karen Dickey" className="swiper-slide">
						<div className="img-box popup-youtube" data-ga={'Home - We collaborate closely with teachers - Karen Dickey'} onClick={this.openModal.bind(null,'MMbIMB1eQ9U')}>
							<img src="../img/learn1.jpg" alt="Karen Dickey, middle school math coordinator for Westport School discusses the partnership between Westport and HeyMath"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Our Learnings - We collaborate closely with teachers - Maheshwari Natarajan" className="swiper-slide">
						<div className="img-box popup-youtube" data-ga={'Home - We collaborate closely with teachers - Maheshwari Natarajan'} onClick={this.openModal.bind(null,'RGZ8kSxUi8Y')}>
							<img src="../img/learn2.jpg" alt="Ms.Maheshwari Nataraja, Vidya Mandir Estancia  principal shares her feedback about HeyMath!"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Our Learnings - We collaborate closely with teachers - Swathi Ashar" className="swiper-slide">
						<div className="img-box popup-youtube" data-ga={'Home - We collaborate closely with teachers - Swathi Ashar'} onClick={this.openModal.bind(null,'5QyaHbY6EX0')}>
							<img src="../img/learn3.jpg" alt="Ms.Swathi Ashar, Bombay International School math co-ordinator shares her feedback"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Our Learnings - We collaborate closely with teachers - Ms Jemila" className="swiper-slide">
						<div className="img-box popup-youtube" data-ga={'Home - We collaborate closely with teachers - Ms Jemila'} onClick={this.openModal.bind(null,'Yqqb_xHarMQ')}>
							<img src="../img/learn4.jpg" alt="Ms.Jemila, GIIS math teacher shares her experience using HeyMath!"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Our Learnings - We collaborate closely with teachers - Meena Meyyappan" className="swiper-slide">
						<div className="img-box popup-youtube" data-ga={'Home - We collaborate closely with teachers - Meena Meyyappan'} onClick={this.openModal.bind(null,'c3Z2ty6gwv4')}>
							<img src="../img/learn5.jpg" alt="Ms.Meena Meyyappan, Honey bunch school, Pollachi shares her comments on HeyMath!"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Our Learnings - We collaborate closely with teachers - N Rama Devi" className="swiper-slide">
						<div className="img-box popup-youtube" data-ga={'Home - We collaborate closely with teachers - N Rama Devi'} onClick={this.openModal.bind(null,'jKx6LKHFIqs')}>
							<img src="../img/learn6.jpg" alt="Ms.N.Rama Devi, Vidya Niketan Public School math teacher shares her feedback about HeyMath!"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>					
					
				</Swiper>
				<div className="slider-btns">
	        		<div className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
	        		<div className="swiper-button-next swp-next"  onClick={this.goNext}></div>
        		</div>
			</div> 
		</div>
		<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
	</section>
  	);
  }
}

export default OurTeachers;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/OurTeachers.js